exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".galaxy\\:\\:common-canvas-editor-canvas-pageOverlay-SelectionAlternatives button[data-v-7e916914]{outline:0}.galaxy\\:\\:common-canvas-editor-canvas-pageOverlay-SelectionAlternatives button i.icon[data-v-7e916914]{color:#3182ce}", ""]);

